import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

import Styles from "components/alerts/Notification.module.scss";
import { UiActions } from "state/actions/UiActions";
import { NotifsActions } from "state/actions/user/NotifsActions";
import { Glambox } from "components/icons/Glambox";
import { Link, NavLink } from "react-router-dom";

/*
 NOTIFICATIONS TYPE
 notificationType: 9 => "" - Quando vc recebe mensagem para ver o e-mail - TITULO: "Você recebeu um e-mail importante!"
 notificationType: 6 => "/#/Glampoints" - Quando muda de jóia - Mostra qual a nome da nova joia
 notificationType: 3 => "/Glamgirl/HistoricoDePontos" - Quando a assinante fez uma troca no Glamclub - Mostra a troca realizada
 notificationType: 0 => "" - Quando sua amiga assina a Glambox - Mensagem mostrando qual amiga e quantos Glampoints vc ganha - TITULO: "Sua amiga assinou a Glambox"
*/
class Notification extends Component {
  render () {
    
    let { notification } = this.props;

    return (
      <div id={`notification-${notification.notificationId}`}
           className={Styles["gb-notifs__item"]}>
        <div className={Styles["gb-notifs__item-icon"]}>
          { this._renderIcon() }
        </div>
        <div className={Styles["gb-notifs__item-text"]}>
          <h5>{notification.title}</h5>
          <p>{notification.content}</p>
          { this._renderDismissButton() }
          <div className={ Styles["gb-notifs__item-text-action"] }>
            <small>{(new Date (notification.dateCreated)).toLocaleDateString()}</small>
            { this._renderLink() }
          </div>
        </div>
      </div>
    );
  }

  _dismissNotification = (id) => {
    return () => {
      this.props.dismissNotification(id);
    };
  };

  _renderDismissButton = () => {
    let { notification } = this.props;

    if (notification.dateRead !== null) {
      return (
        <svg className={Styles["gb-notifs__item-readed"]}
             width="9.536"
             height="7.112"
             viewBox="0 0 9.536 7.112">
          <path d="M105.6,305.6a1.132,1.132,0,0,0-1.6,0l-4.048,4.048-1.624-1.624a1.132,1.132,0,0,0-1.6,1.6l2.424,2.424a1.132,1.132,0,0,0,1.6,0L105.6,307.2A1.132,1.132,0,0,0,105.6,305.6Z"
                transform="translate(-96.4 -305.266)"
                fill="#ff7da5"/>
        </svg>
      );
    }
    return (
      <button className={Styles["gb-notifs__item-readCheck"]}
              onClick={this._dismissNotification(notification.notificationId)}
              title="Marcar como lida">
        <span></span>
      </button>
    );
  };

  _renderIcon = () => {
    let { notification } = this.props;

    switch (notification.notificationType) {
      case 9:
        return (
          <Glambox fill={"#ff7da5"} size={"100%"}/>
        );
      default:
        return(
          <svg width="16" height="11.275" viewBox="0 0 16 11.275">
            <path d="M13.1,44.209H2.9L0,48.074l8,7.411,8-7.41Zm-2.054,4.145L8,54.344l-3.021-5.99Zm-5.785-.638L8,44.979l2.738,2.738Zm3.507-2.87h3.7l-1.046,2.659ZM4.612,47.465l-.873-2.618H7.23Zm-.345.889,2.652,5.26-5.678-5.26Zm7.5,0h3L9.094,53.6Zm.268-.638,1-2.54,1.905,2.54ZM3.113,44.985l.91,2.731H1.065Z" transform="translate(0 -44.209)" fill="#ff7da5"/>
          </svg>
        );
    }
  };

  _renderLink = () => {
    let { notification } = this.props;

    if (notification.actionLink && notification.actionLink.trim() !== "") {

      let linkVerifyLink;

      switch (notification.actionLink.trim()) {
        case '/glampoints':
        case '/#/Glampoints':
        case '/Glamgirl/HistoricoDePontos':
          linkVerifyLink = '/glampoints';
          break;
        case '/#upload-glambox':
          linkVerifyLink = '/glampartner/divulgacao';
          break;
        default:
          linkVerifyLink = notification.actionLink;
          break;
      }
    
      return(

        <NavLink
          to={ linkVerifyLink }
          onClick={this.props.closeNotifs}
        >Verificar </NavLink>

      )
       
      // return null;
    } else {
      return null;
    }
  };
}

Notification.propTypes = {
  notification: PropTypes.shape({
    actionLink: PropTypes.string,
    content: PropTypes.string,
    dateCreated: PropTypes.number,
    dateDismiss: PropTypes.number,
    dateRead: PropTypes.number,
    isPush: PropTypes.bool,
    notificationId: PropTypes.number,
    notificationType: PropTypes.number,
    personId: PropTypes.number,
    title: PropTypes.string
  }).isRequired
};

const mapStateToProps = (state) => ({
  ui: state.ui,
  notifs: state.notifs.data,
  token: state.token.data
});

const mapDispatchToProps = (dispatch) => ({
  dismissNotification: (notificationId) => {
    dispatch(NotifsActions.dismiss(notificationId));
  },
  closeNotifs: () => {
    dispatch(UiActions.notifsHide())
  }
});

Notification = connect(mapStateToProps, mapDispatchToProps)(Notification);

export {
  Notification
};
